var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('administration-offers-layout',{attrs:{"title":"Список направлений","error-text":"Список направлений не загружен","api-method":_vm.getEmployeesDepartments}})
}
var staticRenderFns = []

export { render, staticRenderFns }